import React, { useState, useEffect } from "react";
import {
  Button,
  Form,
  Grid,
  theme,
  Alert,
  Radio,
  Space,
  ConfigProvider,
  Modal,
} from "antd";
import { Col, Row } from "antd";
import { useUiState } from "helpers/useUiState";
import { useNavigate } from "react-router-dom";
import { } from "antd";
import i18n from "i18next";
import { clearLocalStore } from "helpers/localStoreSrv";
import { InputText, InputTextNumber } from "hlsreact";
import BrandColors from "@brand-colors";
import { useAddressVerificationSrv } from "./useAddressVerificationSrv";
import ReactGA from "react-ga";
import { t } from "i18next";
import { handleErrorNavigation } from "pages/ErrorPage/ErrorHandler";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import whitelabelConfig from "@whitelabel-config";
const { useToken } = theme;
const { useBreakpoint } = Grid;
type SizeType = Parameters<typeof Form>[0]["size"];

const AddressVerification = ({ onDataFromChild }) => {
  const [componentSize, setComponentSize] = useState<SizeType | "default">(
    "default"
  );
  const { token } = useToken();
  const screens = useBreakpoint();
  const onFormLayoutChange = ({ size }: { size: SizeType }) => {
    setComponentSize(size);
  };
  const [addressData, setAdressData] = useState([]);
  const [choices, setChoices] = useState("Other");
  const [pinResetKey, setPinResetKey] = useState(0);
  const [showSaveButton, setshowSaveButton] = useState(1);
  const { isAppLoading } = useUiState();
  const [memberAddress, setMemberAddress] = useState({});
  const [additionalAddresses, setAdditionalAddresses] = useState([]);
  const [showAdditionalAddresses, setShowAdditionalAddresses] = useState(false);
  const [formData, setFormData] = useState({
    AddressLine1: "",
    AddressLine2: "",
    AddressLine3: "",
    AddressCity: "",
    AddressState: "",
    AddressPostalCode: "",
  });
  const [formModalData, setFormModalData] = useState({
    AddressLine1: "",
    AddressLine2: "",
    AddressLine3: "",
    AddressCity: "",
    AddressState: "",
    AddressPostalCode: "",
  });
  const [showSuccess, setShowSuccess] = useState(false);
  const [showFailureMessage, setShowFailureMessage] = useState("");
  const [validationError, setValidationError] = useState(null);
  const uiState = useSelector((state: any) => state.portal.uiState);
  const [modalValidationError, setModalValidationError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [validateSyncAddress, setValidateSyncAddress] = useState(null);
  const [selectedValue, setSelectedValue] = useState(null);
  const location = useLocation();
  const preferredLanguage = useSelector(
    (state: any) => state.portal.uiState.Language
  );
  const [currentLanguage, setCurrentLanguage] = useState(preferredLanguage);
  const [isRightAlign, setIsRightAlign] = useState(false);
  const validateAddress = (data: any) => {
    const schema = {
      AddressLine1: function (value: any) {
        return (
          !!value &&
          /^[^-\s][a-zA-Z0-9_\s-.'-]{3,}$/.test(value) &&
          value.length > 3
        );
      },
      AddressLine2: function (value: any) {
        return (
          !!value &&
          /^[^-\s][a-zA-Z0-9\s.,#$]+$/.test(value) &&
          value.length > 2
        );
      },
      AddressCity: function (value: any) {
        return !!value && /^[^-\s][A-Za-z ]+$/.test(value) && value.length >= 2;
      },
      AddressState: function (value: any) {
        return !!value && /^[^-\s][A-Za-z ]+$/.test(value) && value.length >= 2;
      },
      AddressPostalCode: function (value: any) {
        return !!value && /^\d{5}([\-]?\d{4})?$/.test(value);
      },
    };

    const validate = (object: any, schema: any) =>
      Object.keys(schema)
        .filter((key) => !schema[key](object[key]))
        .map((key) => {
          if (key == "AddressLine1"){
            return `${t("PROFILE_PAGE.ADDRESS_LINE_1_ERROR")}.`; 
          } else if (key == "AddressLine2"){
            return `${t("PROFILE_PAGE.ADDRESS_LINE_2_ERROR")}.`; 
          } else if (key == "AddressCity"){
            return `${t("PROFILE_PAGE.CITY_ERROR")}.`; 
          } else if (key == "AddressState"){
            return `${t("PROFILE_PAGE.STATE_ERROR")}.`; 
          } else if (key == "AddressPostalCode"){
            return `${t("PROFILE_PAGE.PIN_ERROR")}.`; 
          } 
          return `${key} is invalid.`; 
        }
      );
    console.log(schema,"schema")
    const errors = validate(data, schema);

    if (errors.length > 0) {
      setValidationError(errors[0]);
      return false;
    } else {
      setValidationError("");
      return true;
    }
  };

  const handleInputChange = (field: any, value: any) => {
    setFormData({
      ...formData,
      [field]: value,
    });
  };
  const clearForm = () => {
    setFormData({
      AddressLine1: "",
      AddressLine2: "",
      AddressLine3: "",
      AddressCity: "",
      AddressState: "",
      AddressPostalCode: "",
    });
    setPinResetKey((prevKey) => prevKey + 1);
    setValidationError("");
  };
  const handleSubmit = async () => {
    setCurrentLanguage(preferredLanguage)
    const isValid = validateAddress(formData);
    if (isValid) {
      if (choices === "MemberAddress") {
        const addrObj = {
          AddressDetails: formData,
          RequireApproval: false,
        };
        let result: any;
        try {
          result = await submitMemberAddresses(addrObj);
        } catch (error) {
          handleErrorNavigation(error, navigate, t);
        }

        if (result && result.data && result.data.ResponseStatus === 0) {
          setIsModalOpen(true);
          setShowSuccess(true);
          setShowFailureMessage(t("PROFILE_PAGE.ADDRESS_UPDATED_SUCCESSFULLY"));
          setShowFailureMessage(result.data.ResponseMessage);
          ReactGA.event({
            category: "Save Button Click ",
            action: "Address Updated Successfully",
            label: "ThankYou Address Verification Page",
          });

          onDataFromChild(result.data.ResponseMessage);
          setshowSaveButton(0);
        } else {
          setShowSuccess(true);
          setShowFailureMessage(
            t("PROFILE_PAGE.ADDRESS_UPDATED_UNSUCCESSFULL")
          );
          ReactGA.event({
            category: "Save Button Click ",
            action: "Address Updated Unsuccessfully",
            label: "ThankYou Address Verification Page",
          });
        }
      } else {
        let result: any;
        try {
          result = await submitValidateAddresses(formData);
          if (result.data.AddressStatus === 1) {
            setValidateSyncAddress(result.data);
            setIsModalOpen(true);
          } else {
            setIsModalOpen(false);
            setShowSuccess(true);
            setShowFailureMessage(
              t("PROFILE_PAGE.ADDRESS_UPDATED_UNSUCCESSFULL")
            );
            ReactGA.event({
              category: "Save Button Click ",
              action: "Address Updated Unsuccessfully",
              label: "ThankYou Address Verification Page",
            });
          }
        } catch (error) {
          handleErrorNavigation(error, navigate, t);
        }
      }
    }
  };
  const { getMemberAddresses, submitMemberAddresses, submitValidateAddresses } =
    useAddressVerificationSrv();
  const navigate = useNavigate();
  const styles = {
    container: {
      margin: "0 auto",
      padding: screens.md
        ? `${token.paddingXL}px`
        : `${token.sizeXXL}px ${token.padding}px`,
      width: "380px",
    },
    footer: {
      marginTop: token.marginLG,
      textAlign: "center",
      width: "100%",
    },
    forgotPassword: {
      float: "right",
    },
    header: {},
    section: {
      alignItems: "center",
      backgroundColor: token.colorBgContainer,
      display: "flex",
      padding: screens.md ? `0px 0px` : "0px",
      textAlign: "left",
    },
    text: {
      color: token.colorTextSecondary,
    },
    title: {
      fontSize: screens.md ? token.fontSizeHeading2 : token.fontSizeHeading3,
    },
    button: {
      backgroundColor: BrandColors.BUTTON_BG,
      borderRadius: "50px",
      width: "100%",
      marginTop: "15px",
      fontWeight: "bold",
    },
    upload: {
      display: "flex",
      background: "#f00",
    },
    subheader: {
      fontWeight: "600",
      width: "100%",
    },
    addressHeader: {
      fontWeight: "600",
      width: "100%",
      color: BrandColors.HEADER_BG,
      textAlign: isRightAlign ? "right" : "left",
      display: "block",
    },
    buttonWrapper: {
      display: "flex",
      justifyContent: "flex-end",
    },
    buttonClear: {
      backgroundColor: BrandColors.BUTTON_BG,
      borderRadius: "50px",
      width: "auto",
      marginTop: "15px",
      fontWeight: "bold",
      marginRight: "10px",
    },
    buttonSave: {
      backgroundColor: BrandColors.BUTTON_BG,
      borderRadius: "50px",
      width: "auto",
      marginTop: "15px",
      fontWeight: "bold",
    },
    formSec: {
      marginTop: "15px",
      marginLeft: "25px",
    },
    successAlert: {
      margin: 0,
      color: BrandColors.HEADER_BG,
      textAlign: isRightAlign ? "right" : "left",
    },
  };

  const onChangeValue = (event: any) => {
    const value = event.target.value;
    const parts = value.split("+");
    if (value === "MemberAddress") {
      const selected = addressData[value];
      setFormData(selected);
    } else if (value === "Other") {
      clearForm();
    } else {
      const firstPart = parts[0];
      const secondPart = Number(parts[1]);
      setFormData(addressData[firstPart][secondPart]);
    }

    setChoices(event.target.value);
    console.log(event.target.value);
  };

  const onChangeModalValue = (event: any) => {
    const value = event.target.value;
    const selected = validateSyncAddress[value];
    setFormModalData(selected);
    setSelectedValue(event.target.value);
  };
  useEffect(() => {
    console.log("uiState.Language", uiState.Language);
    i18n.changeLanguage(uiState.Language);
  }, []);
  useEffect(() => {    
    try {
      if (whitelabelConfig.uiSettings.rightAlignedLanguage.includes(preferredLanguage) === true) {
        setIsRightAlign(true);
      } else {
        setIsRightAlign(false);
      }
    } catch (e) {
      console.log("Error", e)
      handleErrorNavigation(e, navigate, t);
    }
  }, [preferredLanguage, whitelabelConfig, currentLanguage]);
  useEffect(() => {
    getMemberAddresses()
      ?.then((res) => {
        isAppLoading(false);
        (async () => {
          setAdressData(res.data);
          setMemberAddress(res.data.MemberAddress);
          const additionalAddressesData = res.data.AdditionalAddresses;
          setAdditionalAddresses(additionalAddressesData);
        })();
      })
      .catch((e) => {
        isAppLoading(false);
        clearLocalStore();
        handleErrorNavigation(e, navigate, t);
      });
  }, []);

  const handleModelOk = async () => {
    const addrObj = {
      AddressDetails: formModalData,
      RequireApproval: false,
    };

    if (selectedValue) {
      const result: any = await submitMemberAddresses(addrObj);
      if (result && result.data && result.data.ResponseStatus === 0) {
        setIsModalOpen(true);
        setShowSuccess(true);
        setShowFailureMessage(t("PROFILE_PAGE.ADDRESS_UPDATED_UNSUCCESSFULL"));
        setShowFailureMessage(result.data.ResponseMessage);
        ReactGA.event({
          category: "Save Button Click ",
          action: "Address Updated Successfully",
          label: "ThankYou Address Verification Page",
        });

        onDataFromChild(result.data.ResponseMessage);
        setshowSaveButton(0);
      } else {
        setShowSuccess(true);
        setShowFailureMessage(t("PROFILE_PAGE.ADDRESS_UPDATED_UNSUCCESSFULL"));
        ReactGA.event({
          category: "Save Button Click ",
          action: "Address Updated Unsuccessfully",
          label: "ThankYou Address Verification Page",
        });
      }
    } else {
      setModalValidationError("Please select an address.");
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <section style={styles.section}>
      <div style={{ width: "100%", padding: "15px" }}>
        {!showSuccess ? (
          <div style={styles.header}>
            <ConfigProvider
              theme={{
                token: {
                  colorPrimary: BrandColors.HEADER_BG
                    ? BrandColors.HEADER_BG
                    : "#1677ff",
                  fontFamily: "Montserrat, sans-serif",
                },
              }}
            >
              {location.pathname == "/thankyou" ? (
                <>
                  <div
                    style={{
                      fontSize: "16px",
                      marginBottom: "10px",
                      fontWeight: "bold",
                      color: BrandColors.HEADER_BG,
                    }}
                  >
                    {t("PROFILE_PAGE.MEMEBERADDR_ADDR")}
                  </div>
                  <Radio.Group
                    onChange={onChangeValue}
                    value={choices}
                    // name="MemberAddress"
                    data-testid="test-address-radiogroup"
                  >
                    <Space direction="vertical">
                      <Radio
                        value={"MemberAddress"}
                        data-testid="test-addressmember-radio"
                      >
                        <div style={styles.subheader}>
                          <div>
                            {memberAddress.AddressLine1}
                            {memberAddress.AddressLine2}
                            {memberAddress.AddressLine3}
                          </div>
                          <div>{memberAddress.AddressCity}</div>
                          <div>
                            {memberAddress.AddressState}
                            {memberAddress.AddressPostalCode}
                          </div>
                        </div>
                      </Radio>
                      <Radio
                        value={"Other"}
                        data-testid="test-addressother-radio"
                      >
                        <div style={styles.subheader}>
                          {" "}
                          {t("PROFILE_PAGE.OTHERS")}
                        </div>
                      </Radio>
                    </Space>
                  </Radio.Group>
                </>
              ) : null}
            </ConfigProvider>

            {choices == "Other" ? (
              <div style={styles.formSec}>
                <Row gutter={16}>
                  <Col span={12}>
                    <label style={styles.addressHeader}>
                      {t("PROFILE_PAGE.ADDRESS_LINE_1")}
                    </label>
                    <InputText
                      shape={"round"}
                      value={formData.AddressLine1}
                      onChange={(e: any) =>
                        handleInputChange("AddressLine1", e)
                      }                      
                      primaryColor={token.colorTextSecondary}
                    />
                  </Col>
                  <Col span={12}>
                    <label style={styles.addressHeader}>
                      {t("PROFILE_PAGE.ADDRESS_LINE_2")}
                    </label>
                    <InputText
                      shape={"round"}
                      value={formData.AddressLine2}
                      onChange={(e: any) =>
                        handleInputChange("AddressLine2", e)
                      }
                      primaryColor={token.colorTextSecondary}
                    />
                  </Col>
                  <Col span={12}>
                    <label style={styles.addressHeader}>
                      {t("PROFILE_PAGE.ADDRESS_LINE_3")}{" "}
                    </label>
                    <InputText
                      shape={"round"}
                      value={formData.AddressLine3}
                      onChange={(e: any) =>
                        handleInputChange("AddressLine3", e)
                      }
                      primaryColor={token.colorTextSecondary}
                    />
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={8}>
                    <label style={styles.addressHeader}>
                      {t("PROFILE_PAGE.CITY")}{" "}
                    </label>
                    <InputText
                      shape={"round"}
                      value={formData.AddressCity}
                      onChange={(e: any) => handleInputChange("AddressCity", e)}
                      primaryColor={token.colorTextSecondary}
                    />
                  </Col>
                  <Col span={8}>
                    <label style={styles.addressHeader}>
                      {t("PROFILE_PAGE.STATE")}{" "}
                    </label>
                    <InputText
                      shape={"round"}
                      value={formData.AddressState}
                      onChange={(e: any) =>
                        handleInputChange("AddressState", e)
                      }
                      primaryColor={token.colorTextSecondary}
                    />
                  </Col>
                  <Col span={8}>
                    <label style={styles.addressHeader}>
                      {t("PROFILE_PAGE.PIN")}{" "}
                    </label>
                    <InputTextNumber
                      shape={"round"}
                      value={formData.AddressPostalCode}
                      key={pinResetKey}
                      primaryColor={token.colorTextSecondary}
                      onChange={(value: any) =>
                        handleInputChange("AddressPostalCode", value)
                      }
                    />
                  </Col>
                </Row>
              </div>
            ) : null}
            <Col span={24}>
              {validationError && (
                <Alert style={{marginLeft:"25px",textAlign: isRightAlign ? "right" : "left"}} message={validationError} type="error" />
              )}
            </Col>
            <div style={styles.buttonWrapper}>
              {choices == "Other" ? (
                <Button
                  className="btn btn-default btn-outline-secondary mr-3"
                  type="primary"
                  style={styles.buttonClear}
                  onClick={clearForm}
                  data-testid="test-address-clear-btn"
                >
                  {t("PROFILE_PAGE.CLEAR")}
                </Button>
              ) : null}
              <Button
                className="btn-fab1 btn-forward1"
                type="primary"
                style={styles.buttonSave}
                onClick={handleSubmit}
                data-testid="test-address-save-btn"
              >
                {t("PROFILE_PAGE.SAVE")}
              </Button>
              <Modal
                title={t("PROFILE_PAGE.UPDATE_ADDRESS")}
                open={isModalOpen}
                onOk={handleModelOk}
                onCancel={handleCancel}
                okButtonProps={{
                  style: { backgroundColor: BrandColors.BUTTON_BG },
                }}
                cancelButtonProps={{
                  style: {
                    color: BrandColors.BUTTON_BG,
                    borderColor: BrandColors.BUTTON_BG,
                  },
                }}
              >
                <ConfigProvider
                  theme={{
                    token: {
                      colorPrimary: BrandColors.HEADER_BG
                        ? BrandColors.HEADER_BG
                        : "#1677ff",
                      fontFamily: "Montserrat, sans-serif",
                    },
                  }}
                >
                  <Radio.Group
                    onChange={onChangeModalValue}
                    value={selectedValue}
                  >
                    <Space direction="vertical">
                      <div
                        style={{
                          fontSize: "14px",
                          marginBottom: "0px",
                          fontWeight: "bold",
                          color: BrandColors.HEADER_BG,
                        }}
                      >
                        {t("PROFILE_PAGE.INPUT_ADDRESS")}
                      </div>
                      <Radio value={"InputAddress"}>
                        <div style={styles.subheader}>
                          <div>
                            {validateSyncAddress?.InputAddress.AddressLine1}
                            {validateSyncAddress?.InputAddress.AddressLine2}
                            {validateSyncAddress?.InputAddress.AddressLine3}
                          </div>
                          <div>
                            {validateSyncAddress?.InputAddress.AddressCity}
                          </div>
                          <div>
                            {validateSyncAddress?.InputAddress.AddressState}
                            {
                              validateSyncAddress?.InputAddress
                                .AddressPostalCode
                            }
                          </div>
                        </div>
                      </Radio>
                      <div
                        style={{
                          fontSize: "14px",
                          marginBottom: "0px",
                          fontWeight: "bold",
                          color: BrandColors.HEADER_BG,
                        }}
                      >
                        {t("PROFILE_PAGE.CORRECTED_ADDRESS")}
                      </div>
                      <Radio value={`CorrectedAddress`}>
                        <div style={styles.subheader}>
                          <div>
                            {validateSyncAddress?.CorrectedAddress.AddressLine1}
                            {validateSyncAddress?.CorrectedAddress.AddressLine2}
                            {validateSyncAddress?.CorrectedAddress.AddressLine3}
                          </div>
                          <div>
                            {validateSyncAddress?.CorrectedAddress.AddressCity}
                          </div>
                          <div>
                            {validateSyncAddress?.CorrectedAddress.AddressState}
                            {
                              validateSyncAddress?.CorrectedAddress
                                .AddressPostalCode
                            }
                          </div>
                        </div>
                      </Radio>
                    </Space>
                  </Radio.Group>
                </ConfigProvider>
                {modalValidationError && (
                  <Alert message={modalValidationError} type="error" />
                )}
              </Modal>
            </div>
          </div>
        ) : (
          <>
            <h3 style={styles.successAlert}>{showFailureMessage}</h3>
            <div style={styles.header}>
              <ConfigProvider
                theme={{
                  token: {
                    colorPrimary: BrandColors.HEADER_BG
                      ? BrandColors.HEADER_BG
                      : "#1677ff",
                    fontFamily: "Montserrat, sans-serif",
                    colorText: token.colorTextSecondary
                      ? token.colorTextSecondary
                      : "#1677ff",
                  },
                }}
              >
                {showAdditionalAddresses &&
                  additionalAddresses.map((address, index) => (
                    <Radio key={index} value={`AdditionalAddress${index + 1}`}>
                      <div style={styles.subheader}>
                        <div>
                          {address.AddressLine1}
                          {address.AddressLine2}
                          {address.AddressLine3}
                        </div>
                        <div>{address.AddressCity}</div>
                        <div>
                          {address.AddressState}
                          {address.AddressPostalCode}
                        </div>
                      </div>
                    </Radio>
                  ))}
              </ConfigProvider>
              {choices == "Other" &&
                showFailureMessage !== "Updated Successfully" ? (
                <div style={styles.formSec}>
                  <Row gutter={16}>
                    <Col span={12}>
                      <label style={styles.addressHeader}>
                        {t("PROFILE_PAGE.ADDRESS_LINE_1")}
                      </label>
                      <InputText
                        shape={"round"}
                        value={formData.AddressLine1}
                        primaryColor={token.colorTextSecondary}
                        onChange={(e: any) =>
                          handleInputChange("AddressLine1", e)
                        }
                      />
                    </Col>
                    <Col span={12}>
                      <label style={styles.addressHeader}>
                        {t("PROFILE_PAGE.ADDRESS_LINE_2")}{" "}
                      </label>
                      <InputText
                        shape={"round"}
                        value={formData.AddressLine2}
                        primaryColor={token.colorTextSecondary}
                        onChange={(e: any) =>
                          handleInputChange("AddressLine2", e)
                        }
                      />
                    </Col>
                    <Col span={12}>
                      <label style={styles.addressHeader}>
                        {t("PROFILE_PAGE.ADDRESS_LINE_3")}
                      </label>
                      <InputText
                        shape={"round"}
                        value={formData.AddressLine3}
                        primaryColor={token.colorTextSecondary}
                        onChange={(e: any) =>
                          handleInputChange("AddressLine3", e)
                        }
                      />
                    </Col>
                  </Row>
                  <Row gutter={16}>
                    <Col span={8}>
                      <label style={styles.addressHeader}>
                        {t("PROFILE_PAGE.CITY")}{" "}
                      </label>
                      <InputText
                        shape={"round"}
                        value={formData.AddressCity}
                        primaryColor={token.colorTextSecondary}
                        onChange={(e: any) =>
                          handleInputChange("AddressCity", e)
                        }
                      />
                    </Col>
                    <Col span={8}>
                      <label style={styles.addressHeader}>
                        {t("PROFILE_PAGE.STATE")}{" "}
                      </label>
                      <InputText
                        shape={"round"}
                        value={formData.AddressState}
                        primaryColor={token.colorTextSecondary}
                        onChange={(e: any) =>
                          handleInputChange("AddressState", e)
                        }
                      />
                    </Col>
                    <Col span={8}>
                      <label style={styles.addressHeader}>
                        {t("PROFILE_PAGE.PIN")}{" "}
                      </label>
                      <InputTextNumber
                        shape={"round"}
                        value={formData.AddressPostalCode}
                        primaryColor={token.colorTextSecondary}
                        onChange={(value: any) =>
                          handleInputChange("AddressPostalCode", value)
                        }
                        key={pinResetKey}
                      />
                    </Col>
                  </Row>
                </div>
              ) : null}
              <Col span={24}>
                {validationError && (
                  <Alert message={validationError} type="error" />
                )}
              </Col>
              <div style={styles.buttonWrapper}>
                {choices == "Other" &&
                  showFailureMessage !== "Updated Successfully" ? (
                  <Button
                    className="btn btn-default btn-outline-secondary mr-3"
                    type="primary"
                    style={styles.buttonClear}
                    data-testid="test-address-clear-btn"
                    onClick={clearForm}
                  >
                    {t("PROFILE_PAGE.CLEAR")}
                  </Button>
                ) : null}
                {showSaveButton === 1 ? (
                  <>
                    <Button
                      className="btn-fab1 btn-forward1"
                      type="primary"
                      style={styles.buttonSave}
                      onClick={handleSubmit}
                      data-testid="test-address-save-btn"
                    >
                      {t("PROFILE_PAGE.SAVE")}
                    </Button>
                    <Modal
                      title={t("PROFILE_PAGE.UPDATE_ADDRESS")}
                      open={isModalOpen}
                      onOk={handleModelOk}
                      onCancel={handleCancel}
                      okButtonProps={{
                        style: { backgroundColor: BrandColors.BUTTON_BG },
                      }}
                      cancelButtonProps={{
                        style: {
                          color: BrandColors.BUTTON_BG,
                          borderColor: BrandColors.BUTTON_BG,
                        },
                      }}
                    >
                      <ConfigProvider
                        theme={{
                          token: {
                            colorPrimary: BrandColors.HEADER_BG
                              ? BrandColors.HEADER_BG
                              : "#1677ff",
                            fontFamily: "Montserrat, sans-serif",
                          },
                        }}
                      >
                        <Radio.Group
                          onChange={onChangeModalValue}
                          value={selectedValue}
                        >
                          <Space direction="vertical">
                            <div
                              style={{
                                fontSize: "14px",
                                marginBottom: "0px",
                                fontWeight: "bold",
                                color: BrandColors.HEADER_BG,
                              }}
                            >
                              {t("PROFILE_PAGE.INPUT_ADDRESS")}
                            </div>
                            <Radio value={"InputAddress"}>
                              <div style={styles.subheader}>
                                <div>
                                  {
                                    validateSyncAddress?.InputAddress
                                      .AddressLine1
                                  }
                                  {
                                    validateSyncAddress?.InputAddress
                                      .AddressLine2
                                  }
                                  {
                                    validateSyncAddress?.InputAddress
                                      .AddressLine3
                                  }
                                </div>
                                <div>
                                  {
                                    validateSyncAddress?.InputAddress
                                      .AddressCity
                                  }
                                </div>
                                <div>
                                  {
                                    validateSyncAddress?.InputAddress
                                      .AddressState
                                  }
                                  {
                                    validateSyncAddress?.InputAddress
                                      .AddressPostalCode
                                  }
                                </div>
                              </div>
                            </Radio>
                            <div
                              style={{
                                fontSize: "14px",
                                marginBottom: "0px",
                                fontWeight: "bold",
                                color: BrandColors.HEADER_BG,
                              }}
                            >
                              {t("PROFILE_PAGE.CORRECTED_ADDRESS")}
                            </div>
                            <Radio value={`CorrectedAddress`}>
                              <div style={styles.subheader}>
                                <div>
                                  {
                                    validateSyncAddress?.CorrectedAddress
                                      .AddressLine1
                                  }
                                  {
                                    validateSyncAddress?.CorrectedAddress
                                      .AddressLine2
                                  }
                                  {
                                    validateSyncAddress?.CorrectedAddress
                                      .AddressLine3
                                  }
                                </div>
                                <div>
                                  {
                                    validateSyncAddress?.CorrectedAddress
                                      .AddressCity
                                  }
                                </div>
                                <div>
                                  {
                                    validateSyncAddress?.CorrectedAddress
                                      .AddressState
                                  }
                                  {
                                    validateSyncAddress?.CorrectedAddress
                                      .AddressPostalCode
                                  }
                                </div>
                              </div>
                            </Radio>
                          </Space>
                        </Radio.Group>
                      </ConfigProvider>
                      {modalValidationError && (
                        <Alert message={modalValidationError} type="error" />
                      )}
                    </Modal>
                  </>
                ) : (
                  " "
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </section>
  );
};
export default AddressVerification;
